<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Produtos</span>
        <h3 class="page-title">Editar</h3>
      </d-col>
      <d-col cols="8" class="text-right">
        <d-link class="btn btn-success text-white" href="/admin/produtos/novo">Novo produto</d-link>
      </d-col>
    </d-row>

    <product-page :model="product"/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProductPage from '_modules/product/components/ProductPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ProductModel';

export default {
  name: 'product-edit',
  components: {
    ProductPage,
  },
  computed: {
    product() {
      const { product } = this.$store.state.product;
      if (product) {
        Events.$emit(_LOAD_MODEL_, product);
        return product;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getProduct',
    ]),
    getProductModel() {
      this.getProduct(parseInt(this.$route.params.productId, Number));
    },
    save() {
      this.$refs.productForm.save();
    },
  },
  mounted() {
    if (this.$route.params.productId) {
      this.getProductModel();
    }
  },
};
</script>

